import { bool, func, node, string } from 'prop-types'

import noop from 'shared/utils/noop'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonBlockMenu from 'views/components/molecules/ButtonBlockMenu'
import { buttonTypes } from 'views/utils/propTypes/buttonTypes'

const OffCanvasItem = ({
  href,
  name,
  ghost,
  children,
  id,
  hasSubcategories,
  type,
  goNextHandler,
}) => {
  const itemProps = {
    name,
    ghost,
    href,
    type,
    isReactControlled: true,
    light: true,
    onClick: hasSubcategories
      ? goNextHandler(id, href, { fetchByPath: false })
      : null,
  }

  return (
    <ButtonBlockMenu {...itemProps}>
      {children}
      {hasSubcategories && <IconCaretRight className="u-margin-auto--left" />}
    </ButtonBlockMenu>
  )
}

OffCanvasItem.propTypes = {
  children: node.isRequired,
  href: string,
  name: string,
  ghost: bool,
  hasSubcategories: bool,
  type: buttonTypes,
  goNextHandler: func,
  id: string,
}

OffCanvasItem.defaultProps = {
  href: null,
  name: '',
  ghost: false,
  hasSubcategories: false,
  type: null,
  goNextHandler: noop,
  id: '',
}

export default OffCanvasItem
